export default class webLogin {
    loaded: boolean;
    isLogin: boolean;
	token: string;
    lastCheck: Date;
    validationDate: Date;
    administrator: string;
    companyName: string;
    companyPath: string;
    companyID: string;
    userName: string;

    constructor() {
        this.loaded = false;
        this.isLogin = false;
        this.token = '';
        this.lastCheck = new Date();
        this.validationDate = this.lastCheck;
        this.administrator = "-1"; 
        this.companyName = '';
        this.companyPath = '';
        this.companyID = '';
        this.userName = '';
    }
}